module.exports = new __parcel__URL__("innerfrost.473041e9.png").toString();